// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.YellowCardWrapper{
    background: linear-gradient(90deg, rgb(248, 252, 239) 0%, rgb(239, 255, 243) 100%);
    /* border: 2px solid #edf3dc; */
    padding: 14px;
    border-radius: 8px;
    margin-bottom: 20px;
}

.besicDetailsWrapper{
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 25px 20px;
    width: 95%;
    margin: auto;
}

.familyDetailsWrapper >div >div{
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 25px 20px;
    width: 95%;
    margin: auto;
}
.familyDetailsWrapper >div{
    border-bottom: var(--Table_Header) 2px solid;
    padding-bottom: 20px;
    margin-bottom: 30px;
}

.infoTextWrapper h6{
    margin-bottom: 2px;
    color: #333;
    font-size: 15px;
    font-weight: 600;
}
.documentWrapper >div >div h6{
    margin-bottom: 10px;
    color: #6b748c;
    font-size: 15px;
    
}
.documentWrapper > h6{
    margin-bottom: 14px;
    color: #333;
    font-size: 15px;
    margin-top: 20px;
}
.infoTextWrapper p{
    margin: 0px;
    font-size: 15px;
    color: #6b748c;
}

.YellowCardWrapper >h5{
    color: var(--Primary_color);
    font-size: 20px;
    margin-bottom: 18px;

}

.documentWrapper{
    margin-top:30px;
    font-size: 16px;
    width: 100%;
    display: block !important;
}

.documentWrapper > div{
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 25px 20px;
    width: 100%;
}
.AttachmentImageWrapper >img{
   width: 100px;
   height: 80px;
   cursor: pointer;
   object-fit: cover;
   border-radius: 8px;
   transition: all ease-in-out 0.3s;
}


.AttachmentImageWrapper >img:hover {
    box-shadow: rgba(40, 143, 67, 0.3) 0px 6px 20px 0px;
    transition: all ease-in-out 0.3s;
}

.orgBtnWrapper {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    margin-bottom: 20px;
  }

  .wingHouseBtnWrapper {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 20px;
  }
  
  
  .wingHouseBtnWrapper button {
    text-overflow: ellipsis;
    overflow-x: hidden;
    border-radius: 4px;
    border: 2px solid rgba(142, 207, 120, 0.5);
    padding: 2px 0px ;
    background-color: transparent;
    font-weight: 600;
  }

/* ----------------------- Media Query ---------------------- */

@media (max-width:1200px) {
    .besicDetailsWrapper{
        grid-template-columns: repeat(2, 1fr);
    }
    .familyDetailsWrapper >div >div {
        grid-template-columns: repeat(2, 1fr);
    }

    .wingHouseBtnWrapper {
        grid-template-columns: repeat(3, 1fr);
      }
  }
@media (max-width:800px) {

    .wingHouseBtnWrapper {
        grid-template-columns: repeat(2, 1fr);
      }
  }`, "",{"version":3,"sources":["webpack://./src/components/surveyManagement/surveyManagement.css"],"names":[],"mappings":"AAAA;IACI,kFAAkF;IAClF,+BAA+B;IAC/B,aAAa;IACb,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,cAAc;IACd,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,cAAc;IACd,UAAU;IACV,YAAY;AAChB;AACA;IACI,4CAA4C;IAC5C,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,mBAAmB;IACnB,cAAc;IACd,eAAe;;AAEnB;AACA;IACI,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,2BAA2B;IAC3B,eAAe;IACf,mBAAmB;;AAEvB;;AAEA;IACI,eAAe;IACf,eAAe;IACf,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,cAAc;IACd,WAAW;AACf;AACA;GACG,YAAY;GACZ,YAAY;GACZ,eAAe;GACf,iBAAiB;GACjB,kBAAkB;GAClB,gCAAgC;AACnC;;;AAGA;IACI,mDAAmD;IACnD,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,eAAe;IACf,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,qCAAqC;IACrC,SAAS;EACX;;;EAGA;IACE,uBAAuB;IACvB,kBAAkB;IAClB,kBAAkB;IAClB,0CAA0C;IAC1C,iBAAiB;IACjB,6BAA6B;IAC7B,gBAAgB;EAClB;;AAEF,+DAA+D;;AAE/D;IACI;QACI,qCAAqC;IACzC;IACA;QACI,qCAAqC;IACzC;;IAEA;QACI,qCAAqC;MACvC;EACJ;AACF;;IAEI;QACI,qCAAqC;MACvC;EACJ","sourcesContent":[".YellowCardWrapper{\n    background: linear-gradient(90deg, rgb(248, 252, 239) 0%, rgb(239, 255, 243) 100%);\n    /* border: 2px solid #edf3dc; */\n    padding: 14px;\n    border-radius: 8px;\n    margin-bottom: 20px;\n}\n\n.besicDetailsWrapper{\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 25px 20px;\n    width: 95%;\n    margin: auto;\n}\n\n.familyDetailsWrapper >div >div{\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 25px 20px;\n    width: 95%;\n    margin: auto;\n}\n.familyDetailsWrapper >div{\n    border-bottom: var(--Table_Header) 2px solid;\n    padding-bottom: 20px;\n    margin-bottom: 30px;\n}\n\n.infoTextWrapper h6{\n    margin-bottom: 2px;\n    color: #333;\n    font-size: 15px;\n    font-weight: 600;\n}\n.documentWrapper >div >div h6{\n    margin-bottom: 10px;\n    color: #6b748c;\n    font-size: 15px;\n    \n}\n.documentWrapper > h6{\n    margin-bottom: 14px;\n    color: #333;\n    font-size: 15px;\n    margin-top: 20px;\n}\n.infoTextWrapper p{\n    margin: 0px;\n    font-size: 15px;\n    color: #6b748c;\n}\n\n.YellowCardWrapper >h5{\n    color: var(--Primary_color);\n    font-size: 20px;\n    margin-bottom: 18px;\n\n}\n\n.documentWrapper{\n    margin-top:30px;\n    font-size: 16px;\n    width: 100%;\n    display: block !important;\n}\n\n.documentWrapper > div{\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 25px 20px;\n    width: 100%;\n}\n.AttachmentImageWrapper >img{\n   width: 100px;\n   height: 80px;\n   cursor: pointer;\n   object-fit: cover;\n   border-radius: 8px;\n   transition: all ease-in-out 0.3s;\n}\n\n\n.AttachmentImageWrapper >img:hover {\n    box-shadow: rgba(40, 143, 67, 0.3) 0px 6px 20px 0px;\n    transition: all ease-in-out 0.3s;\n}\n\n.orgBtnWrapper {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 20px;\n    margin-bottom: 20px;\n  }\n\n  .wingHouseBtnWrapper {\n    display: grid;\n    grid-template-columns: repeat(4, 1fr);\n    gap: 20px;\n  }\n  \n  \n  .wingHouseBtnWrapper button {\n    text-overflow: ellipsis;\n    overflow-x: hidden;\n    border-radius: 4px;\n    border: 2px solid rgba(142, 207, 120, 0.5);\n    padding: 2px 0px ;\n    background-color: transparent;\n    font-weight: 600;\n  }\n\n/* ----------------------- Media Query ---------------------- */\n\n@media (max-width:1200px) {\n    .besicDetailsWrapper{\n        grid-template-columns: repeat(2, 1fr);\n    }\n    .familyDetailsWrapper >div >div {\n        grid-template-columns: repeat(2, 1fr);\n    }\n\n    .wingHouseBtnWrapper {\n        grid-template-columns: repeat(3, 1fr);\n      }\n  }\n@media (max-width:800px) {\n\n    .wingHouseBtnWrapper {\n        grid-template-columns: repeat(2, 1fr);\n      }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
